<template>
  <section>
    <AprobarProgramacionJefeJerarquico />
    <AprobarProgramacionJefeJerarquicoNoDependencia />
    <RechazarProgramacionJefeJerarquico />
    <ValidarProgramacionJefeJerarquicoDependencia />
    <ValidarProgramacionJefeJerarquicoNoDependencia />
    <VerDetalleSolicitudes />
    <VerDetalleSolicitudesProgramacion />
    <ValidarProgramacionJefeJerarquicoPorFuncionario />

    <v-layout row wrap>
      <v-flex shrink>
        <v-btn
          icon
          color="primary"
          :to="
            `/vacaciones-aprobar-jefe-superior/${this.$route.params.gestion}`
          "
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-flex>
      <v-flex shrink
        ><h3 class="primary--text">
          <v-icon color="primary">people</v-icon>
          Programación de vacaciones
        </h3></v-flex
      >
    </v-layout>

    <v-card elevation="0">
      <v-card-text class="py-0">
        <strong>DEPENDENCIA: </strong
        >{{ this.$util.decodeString(this.$route.params.nombre_unidad) }}
        <br />
        <strong>AÑO DE PROGRAMACIÓN: </strong>{{ this.$route.params.gestion }}

        <v-layout>
          <!-- Boton validar dependencia  -->
          <!-- <v-tooltip
            bottom
            v-if="this.user.unidad[0].id == this.$route.params.id_unidad"
          >
            <v-btn
              color="rgba(156, 80, 162 ,0.3)"
              @click.prevent="validarProgramacionJefeJerarquicoDependencia()"
              slot="activator"
              ><v-icon dark>done</v-icon>Validar programación
            </v-btn>
            <span>Validar programaciones</span>
          </v-tooltip> -->
          <!-- Boton aprobar dependencia-->
          <!-- <v-tooltip
            bottom
            v-if="this.user.unidad[0].id == this.$route.params.id_unidad"
          >
            <v-btn
              color="rgba(103,15,121,0.6)"
              @click.prevent="aprobarProgramacionJefeJerarquico()"
              slot="activator"
              ><v-icon dark>play_arrow</v-icon>Aprobar programación dependencia
            </v-btn>
            <span>Aprobar</span>
          </v-tooltip> -->
          <!-- Boton validar no dependencia -->
          <!-- <v-tooltip
            bottom
            v-if="this.user.unidad[0].id != this.$route.params.id_unidad"
          >
            <v-btn
              color="rgba(156, 80, 162 ,0.3)"
              @click.prevent="validarProgramacionJefeJerarquicoNoDependencia()"
              slot="activator"
              ><v-icon dark>done</v-icon>Validar programación
            </v-btn>
            <span>Validar programaciones</span>
          </v-tooltip> -->
          <!-- Boton aprobar no dependencia-->
          <!-- <v-tooltip
            bottom
            v-if="this.user.unidad[0].id != this.$route.params.id_unidad"
          >
            <v-btn
              color="rgba(103,15,121,0.6)"
              @click.prevent="aprobarProgramacionJefeJerarquicoNoDependencia()"
              slot="activator"
              ><v-icon dark>play_arrow</v-icon>Aprobar programación
            </v-btn>
            <span>Aprobar</span>
          </v-tooltip> -->
          <!-- Boton filtro -->
          <v-tooltip bottom>
            <v-btn
              @click.native="
                () => {
                  filterShow = !filterShow;
                }
              "
              class="btn-refresh"
              slot="activator"
              ><v-icon>filter_list</v-icon>
            </v-btn>
            <span>Búsqueda/filtros</span>
          </v-tooltip>
          <!-- Boton acutualizar -->
          <v-tooltip bottom>
            <v-btn
              @click.native="cargarProgramacionesGeneral()"
              class="btn-refresh"
              slot="activator"
              ><v-icon>refresh</v-icon>
            </v-btn>
            <span>{{ $t("common.updateList") }}</span>
          </v-tooltip>
        </v-layout>
        <!-- Filtros-->
        <v-flex xs12>
          <transition name="slide-fade">
            <div class="filter-container-rrhh" v-show="filterShow">
              <v-icon small color="primary">search</v-icon>
              <div class="filter-item">
                <v-text-field
                  label="Servidor público"
                  v-model="form.servidor_publico"
                  @input="filterServidorPublico"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha incorporación"
                  @input="filterFechaIncorporacion"
                  v-model="form.fecha_incorporacion"
                ></v-text-field>
              </div>

              <!-- botones cerrar -->
              <div class="btn-filter">
                <v-tooltip bottom>
                  <v-btn icon small slot="activator" @click.native="recargar()">
                    <v-icon small>refresh</v-icon>
                  </v-btn>
                  <span>Recargar filtros</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="
                      () => {
                        filterShow = false;
                        recargar();
                      }
                    "
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <span>Cerrar filtros</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </v-flex>

        <br />
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="lista_funcionarios_vacaciones"
          :no-data-text="loading ? 'Cargando...' : 'Sin datos'"
          :loading="loading"
          item-key="id"
          :search="filters"
          :custom-filter="customFilter"
          no-results-text="No se encontro coincidencias"
          :rows-per-page-items="[5, 10, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Filas por pagina"
          hide-actions
        >
          <!-- Cabecera -->
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="letra-cabecera">
                  {{ props.header.text }}
                </span>
              </template>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>

          <template v-slot:items="items">
            <td class="text-xs-center">{{ items.item.servidor_publico }}</td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_incorporacion).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">{{ items.item.dias_saldo_a }}</td>
            <td class="text-xs-center">{{ items.item.dias_saldo_b }}</td>
            <td class="text-xs-center">{{ items.item.dias_saldo_c }}</td>
            <td class="text-xs-center">{{ items.item.total_dias_saldo }}</td>
            <td class="text-xs-center">{{ items.item.dias_programar }}</td>
            <td class="text-xs-center">{{ items.item.dias_no_programados }}</td>
            <td class="text-xs-center">
              {{ items.item.ene != 0 ? items.item.ene : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.feb != 0 ? items.item.feb : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.mar != 0 ? items.item.mar : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.abr != 0 ? items.item.abr : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.may != 0 ? items.item.may : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.jun != 0 ? items.item.jun : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.jul != 0 ? items.item.jul : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.ago != 0 ? items.item.ago : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.sep != 0 ? items.item.sep : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.oct != 0 ? items.item.oct : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.nov != 0 ? items.item.nov : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.dic != 0 ? items.item.dic : "-" }}
            </td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td>
              <v-btn
                v-if="items.item.id_estado_vacac_progra != 22"
                color="#0594A5"
                dark
                @click.prevent="verDetalleProgramacion(items.item)"
                icon
                title="Ver detalle"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                v-if="items.item.id_estado_vacac_progra != 22"
                color="#6DE0BA"
                dark
                @click.prevent="verDetalle(items.item)"
                icon
                title="Descripción"
              >
                <v-icon>receipt</v-icon>
              </v-btn>
              <!-- <v-btn
                v-if="
                  items.item.id_estado_vacac_progra != 22 
                "
                color="#0594A5"
                @click.prevent="verDetalleProgramacion(items.item)"
                icon
                title="Ver detalle"
              >
                <v-icon>receipt</v-icon>
              </v-btn> -->
              <!-- Rechazar dependencia -->
              <v-btn
                v-if="
                  user.unidad[0].id == $route.params.id_unidad &&
                    items.item.id_estado_vacac_progra == 51
                "
                color="#FF5D34"
                dark
                @click.prevent="rechazarProgramacionJefeJerarquico(items.item)"
                icon
                title="Rechazar"
              >
                <v-icon>close</v-icon>
              </v-btn>
              <!-- Rechazar no dependencia -->

              <v-btn
                v-if="
                  user.unidad[0].id != $route.params.id_unidad &&
                    items.item.id_estado_vacac_progra == 66
                "
                color="#FF5D34"
                dark
                @click.prevent="rechazarProgramacionJefeJerarquico(items.item)"
                icon
                title="Rechazar"
              >
                <v-icon>close</v-icon>
              </v-btn>
              <!-- Validar dependencia-->
              <!-- <v-btn
                color="#f1b3f6"
                v-if="
                  user.unidad[0].id == $route.params.id_unidad &&
                    items.item.id_estado_vacac_progra == 51
                "
                @click="validarProgramacionJefeJerarquicoPorFuncionario(items.item)"
                icon
                title="Validar programación"
              >
                <v-icon>done</v-icon>
              </v-btn> -->
              <!-- Validar no dependencia-->
              <!-- <v-btn
                color="#f1b3f6"
                v-if="
                  user.unidad[0].id != $route.params.id_unidad &&
                    items.item.id_estado_vacac_progra == 66
                "
                @click="validarProgramacionJefeJerarquicoPorFuncionario(items.item)"
                icon
                title="Validar programación"
              >
                <v-icon>done</v-icon>
              </v-btn> -->
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import VerDetalleSolicitudes from "./dialogs/VerDetalleSolicitudes";
import VerDetalleSolicitudesProgramacion from "./dialogs/VerDetalleSolicitudesProgramacion";
import AprobarProgramacionJefeJerarquico from "./dialogs/AprobarProgramacionJefeJerarquico";
import ValidarProgramacionJefeJerarquicoDependencia from "./dialogs/ValidarProgramacionJefeJerarquicoDependencia";
import ValidarProgramacionJefeJerarquicoNoDependencia from "./dialogs/ValidarProgramacionJefeJerarquicoNoDependencia";
import AprobarProgramacionJefeJerarquicoNoDependencia from "./dialogs/AprobarProgramacionJefeJerarquicoNoDependencia";
import RechazarProgramacionJefeJerarquico from "./dialogs/RechazarProgramacionJefeJerarquico";
import ValidarProgramacionJefeJerarquicoPorFuncionario from "./dialogs/ValidarProgramacionJefeJerarquicoPorFuncionario";

import filtros from "./mixins/filtros";
export default {
  mixins: [filtros],
  data() {
    return {
      form: {},
      persona: null,
      loading: false,
      img_url: "",
      funcionario: null,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      persona: null,
      saldo: null,
      es_vice_min: false,
      user: this.$storage.get("user"),
      // variables datatable
      lista_funcionarios_vacaciones: [],
      gestion: parseInt(this.$route.params.gestion),
      unidad: this.$storage.get("user").unidad[0],
      // Variables filtros
      filterShow: true,
      filters: {
        servidor_publico: "",
        fecha_incorporacion: "",
        saldo_corte: "",
        dias_asignados: "",
        dias_programar: ""
      }
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Servidor público",
          value: "id",
          align: "center"
        },
        {
          text: "Fecha de incorporación",
          value: "fecha_solicitud",
          align: "center"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 3}-${this.gestion -
            2}\n(A)`,
          value: "dias_saldo_a",
          align: "center"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 2}-${this.gestion -
            1}\n(B)`,
          value: "dias_saldo_b",
          align: "center"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 1}-${
            this.gestion
          }\n(C)`,
          value: "dias_saldo_c",
          align: "center"
        },
        {
          text: `TOTAL DIAS\n(A+B+C)`,
          value: "total_dias_saldo",
          align: "center"
        },
        {
          text: `TOTAL DIAS PROGRAMADOS DE ACUERDO A PORCENTAJE`,
          value: "dias_programar",
          align: "center"
        },
        {
          text: `TOTAL DIAS NO PROGRAMADOS`,
          value: "dias_no_programados",
          align: "center"
        },
        { text: "Ene", value: "ene", align: "center" },
        { text: "Feb", value: "feb", align: "center" },
        { text: "Mar", value: "mar", align: "center" },
        { text: "Abr", value: "abr", align: "center" },
        { text: "May", value: "may", align: "center" },
        { text: "Jun", value: "jun", align: "center" },
        { text: "Jul", value: "jul", align: "center" },
        { text: "Ago", value: "ago", align: "center" },
        { text: "Sep", value: "sep", align: "center" },
        { text: "Oct", value: "oct", align: "center" },
        { text: "Nov", value: "nov", align: "center" },
        { text: "Dic", value: "dic", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        {
          text: this.$t("common.actions"),
          sortable: false,
          align: "center"
        }
      ];
    }
  },
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on(
      "closeDialogValidarProgramacionJefeJerarquicoNoDependencia",
      async () => {
        await this.cargarProgramacionesGeneral();
      }
    );
    this.$bus.$on(
      "closeDialogAprobarProgramacionJefeJerarquicoNoDependencia",
      async () => {
        await this.cargarProgramacionesGeneral();
      }
    );
    this.$bus.$on("closeDialogValidarJerarquicoDependencia", async () => {
      await this.cargarProgramacionesGeneral();
    });
    this.$bus.$on("closeDialogRechazarProgramacionJefeJerarquico", async () => {
      await this.cargarProgramacionesGeneral();
    });
    this.$bus.$on(
      "closeDialogValidarProgramacionJefeJerarquicoPorFuncionario",
      async () => {
        await this.cargarProgramacionesGeneral();
      }
    );
    this.$bus.$on("closeDialogAproJerarquico", async () => {
      await this.cargarProgramacionesGeneral();
    });
    this.$bus.$on("closeDialog", async () => {
      await this.cargarProgramacionesGeneral();
    });
    this.$bus.$on("closeDialogAprobJefeSup", async () => {
      await this.cargarProgramacionesGeneral();
    });
    this.getAño();
    await this.cargarProgramacionesGeneral();
    this.es_vice_min = await this.compruebaViceMin();
  },

  methods: {
    getAño() {
      let año = new Date().getFullYear() + "";
      return año;
    },
    aprobarProgramacionJefeJerarquicoNoDependencia() {
      this.$bus.$emit(
        "openDialogAprobarProgramacionJefeJerarquicoNoDependencia"
      );
    },
    async aprobarProgramacionJefeJerarquico() {
      let item = {};
      item.nro_item = await this.obtenerItem();
      this.$bus.$emit("openDialogAprobarProgramacionJefeJerarquico", item);
    },
    async validarProgramacionJefeJerarquicoDependencia() {
      let item = {};
      item.nro_item = await this.obtenerItem();
      this.$bus.$emit(
        "openDialogValidarProgramacionJefeJerarquicoDependencia",
        item
      );
    },
    rechazarProgramacionJefeJerarquico(item) {
      item.gestion = this.gestion;
      this.$bus.$emit("openDialogRechazarProgramacionJefeJerarquico", item);
    },
    validarProgramacionJefeJerarquicoNoDependencia(item) {
      this.$bus.$emit(
        "openDialogValidarProgramacionJefeJerarquicoNoDependencia",
        item
      );
    },
    validarProgramacionJefeJerarquicoPorFuncionario(item) {
      this.$bus.$emit(
        "openDialogValidarProgramacionJefeJerarquicoPorFuncionario",
        item
      );
    },
    //Metodo para verificar si es viceministro o ministro
    async compruebaViceMin() {
      try {
        let es_especial = false;
        let res;
        // Retiro por desvinculacion
        res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "SELECT movilidad.fn_pregunta_cargo_viceministros(${parseInt(
                  this.user.id_persona
                )})"){
                  respuesta
                }
              }
            `
        });
        res = res.runQuery.respuesta[0].fn_pregunta_cargo_viceministros;
        if (res) {
          res = res.split("|");
          if (parseInt(res[0]) == 1) {
            if (res[1] == "SI") {
              es_especial = true;
            }
          } else {
            this.$message.error(res[1]);
          }
        }
        return es_especial;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerItem() {
      let user = this.$storage.get("user");
      try {
        let nro_item = null;
        let rpta = await this.$service.graphql({
          query: `
					query{
            vMovimientosMovilidads(id_persona:${parseInt(
              user.id_persona
            )},id_estado:1){
              rows{
                id_persona
                nro_item
                unidad
                id_unidad
                id_estado
              }
            }
          }
					`
        });
        if (rpta.vMovimientosMovilidads.rows.length != 0) {
          nro_item = rpta.vMovimientosMovilidads.rows[0].nro_item;
        }
        return nro_item;
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para cargar el listado
    async cargarProgramacionesGeneral() {
      try {
        let res = [];
        let usuario = this.$storage.get("user");
        if (this.user.unidad[0].id && this.$route.params.id_unidad) {
          this.loading = true;
          if (this.user.unidad[0].id == this.$route.params.id_unidad) {
            let item = await this.obtenerItem();
            res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad_jerarquicos(${this.$route.params.id_unidad},${this.$route.params.gestion},${usuario.id_persona})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });
          } else {
            res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad(${this.$route.params.id_unidad},${this.$route.params.gestion})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });
          }
          this.loading = false;
          res = res.runQuery.respuesta;
          this.lista_funcionarios_vacaciones = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para abrir dialog detalle
    verDetalle(item) {
      item.gestion = this.gestion;
      this.$bus.$emit("openDialogVerDetalleSolicitudes", item);
    },
    verDetalleProgramacion(item) {
      this.$bus.$emit("openDialogVerDetalleSolicitudesProgramacion", item);
    }
  },
  components: {
    VerDetalleSolicitudes,
    VerDetalleSolicitudesProgramacion,
    AprobarProgramacionJefeJerarquico,
    RechazarProgramacionJefeJerarquico,
    ValidarProgramacionJefeJerarquicoDependencia,
    ValidarProgramacionJefeJerarquicoNoDependencia,
    ValidarProgramacionJefeJerarquicoPorFuncionario,
    AprobarProgramacionJefeJerarquicoNoDependencia
  }
};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/VerDetalleProgramacionJerarquico.vue